import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Sparkles } from 'lucide-react';

const CURRENT_VERSION = '1.8.1';

const CHANGELOG = [
  {
    version: '1.8.1',
    title: 'Novedades de esta versión',
    features: [
      {
        category: 'Comisiones',
        items: [
          'Cancelación de comisiones pendientes: botón "Cancelar" en cada tarjeta (solo admin) con motivo opcional',
          'Badge rojo "Cancelada" con fecha, admin y motivo en el historial',
          'Filtro por estado "Cancelada" en el módulo de comisiones',
          'Manual actualizado con desglose de líneas y uso de filtros',
        ],
      },
    ],
  },
  {
    version: '1.8.0',
    title: 'Versión anterior',
    features: [
      {
        category: 'Comisiones',
        items: [
          'Nuevo módulo de comisiones: se calculan automáticamente al facturar, entregar pedidos de confección y órdenes de servicio',
          'Tasas configurables por categoría de producto (% o monto fijo por unidad) en Configuración → Comisiones',
          'Pago múltiple: selecciona varias comisiones con checkbox y liquídalas en un clic',
          'Número de liquidación (LIQ-000001) por cada pago individual o en lote',
          'Comprobante PDF de liquidación descargable y enviable por correo al vendedor',
          'Toggle por usuario para activar o desactivar generación de comisiones',
        ],
      },
      {
        category: 'Pedidos de Confección',
        items: [
          'Al marcar ENTREGADO con balance pendiente, el sistema pide cobrar antes de entregar',
          'Opción "Ir a cobrar" marca el pedido como entregado y lleva al POS; la comisión se genera al saldar',
          'Opción "Entregar sin cobrar" permite entregar sin pago (sin generar comisión)',
        ],
      },
      {
        category: 'Órdenes de Servicio',
        items: [
          'Mismo flujo de entrega con balance que los pedidos: modal de advertencia al marcar ENTREGADO con deuda',
          'Comisión sobre el precio de la prenda del catálogo además de los servicios',
        ],
      },
    ],
  },
  {
    version: '1.7.0',
    title: 'Versión anterior',
    features: [
      {
        category: 'Cotizaciones',
        items: [
          'Módulo de cotizaciones renovado: búsqueda de clientes en tiempo real',
          'Conversión directa a factura desde el POS con validación de stock',
          'PDF con logo y datos del negocio, descarga, impresión y envío por correo',
          'Fecha de validez por defecto de 30 días',
        ],
      },
      {
        category: 'Notas de Crédito',
        items: [
          'Creación automática de NC al cancelar pedidos y órdenes de servicio',
          'Correo automático al administrador con número de NC al cancelar',
          'Soporte de pago mixto NC + método en factura PDF y cuadre de caja',
          'Opción de imprimir NC directamente desde el listado',
        ],
      },
      {
        category: 'Reportes',
        items: [
          'Nuevos KPIs: Ventas Brutas, Ventas Netas, NC Emitidas, Facturas Emitidas',
          'Exportación Excel con 5 hojas: Resumen, Ventas por día, Detalle de facturas, NC Emitidas, Top Productos',
        ],
      },
      {
        category: 'General',
        items: [
          'Nombres de clientes siempre con iniciales en mayúscula',
        ],
      },
    ],
  },
];

const STORAGE_KEY = 'whats_new_seen_version';

const WhatsNew = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(STORAGE_KEY);
    if (seen !== CURRENT_VERSION) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, CURRENT_VERSION);
    setOpen(false);
  };

  const entry = CHANGELOG[0];

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleClose(); }}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl" style={{ fontFamily: 'Outfit' }}>
            <Sparkles className="w-5 h-5 text-cyan-500" />
            {entry.title}
            <span className="ml-auto text-sm font-normal text-slate-400">v{entry.version}</span>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-5 py-2">
          {entry.features.map((section) => (
            <div key={section.category}>
              <p className="text-xs font-semibold text-cyan-600 uppercase tracking-wide mb-2">
                {section.category}
              </p>
              <ul className="space-y-1.5">
                {section.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-cyan-400 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-2">
          <Button
            onClick={handleClose}
            className="w-full bg-cyan-500 hover:bg-cyan-600 text-white"
          >
            Entendido
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WhatsNew;
